unit TermListGetRequest;
{

/* Initial. */

}
interface

uses
  SysUtils,
  BaseRequest;

type
  TTermListGetRequest = class(TBaseRequest)
  private
    fLanguage: String;
    fInternal: Byte;
  public
    constructor Create(const String_LoginKey: String; const String_Language: String; const Byte_Internal: Byte);
    function ToJSON: String; override;
  end;

implementation

constructor TTermListGetRequest.Create(const String_LoginKey: String; const String_Language: String; const Byte_Internal: Byte);
begin
  inherited Create(String_LoginKey);

  fLanguage := String_Language;
  fInternal := Byte_Internal;
end;

function TTermListGetRequest.ToJSON: String;
begin
  Result := '{"loginKey":"' + LoginKey + '","language":"' + fLanguage + '","internal":"' + IntToStr(fInternal) + '"}';
end;

end.
